import qs from 'query-string';

export const buildRedirect = (pathname, location) => {
  const redirect = location.pathname + location.search;
  const search = qs.stringify({ redirect });
  return { pathname, search };
};
